
import BScroll from "@better-scroll/core"
import { formatWareImgUrl } from "@/utils/utils"
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    giftList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.initImgView()
  },
  methods: {
    initImgView() {
      let width = 0
      if (this.list.length) {
        width = this.list.length * (0.78 + 0.1 + 0.2)
      }
      this.$refs.imgLine.style.width = width + "rem"

      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs.imgView, {
          scrollX: true,
          click: true,
          probeType: 3,
          bounce: {
            left: false,
            right: false
          }
        })
        this.scroll.on("scroll", this.onScroll)
      })
    },
    formatWareImgUrl
  }
}
